import React from "react";

const BasicDetails = ({ data = [], purchaseData = [] }) => {
  
  return (
    <div className="grid grid-cols-2 gap-4">
      {data?.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="flex flex-col font-medium">
            <span className="text-gray-600" aria-label={`Label for ${item.label}`}>
              {item.label}
            </span>
            <span className="text-theme font-bold">{item.value}</span>
          </div>
        ))
      ) : (
        <p className="col-span-2 text-disabled">No details available</p>
      )}

      {purchaseData?.length > 0 && (
        <div className="flex flex-col gap-2 col-span-2">
          {purchaseData?.map((item, index) => (
            <div key={index} className="flex flex-row gap-2 font-medium">
              <span className="text-gray-600" aria-label={`Label for ${item.label}`}>
                {item.label}
              </span>
              <span className="text-theme font-bold">{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(BasicDetails);
